import { useQuery, UseQueryOptions } from "react-query";
import { TopicReleasePolicy } from "./TopicReleasePolicy.model";
import { useTopicReleasePolicyApi } from "./TopicReleasePolicy.api";

type Key = ["topic-release-policy", number, number];

type UseGetTopicReleasePolicyParams<TData = TopicReleasePolicy | null> = {
  topicId: number;
  releaseId: number;
} & UseQueryOptions<TopicReleasePolicy | null, unknown, TData, Key>;

export function useGetTopicReleasePolicy<TData = TopicReleasePolicy | null>({
  topicId,
  releaseId,
  ...options
}: UseGetTopicReleasePolicyParams<TData>) {
  const { getTopicReleasePolicy } = useTopicReleasePolicyApi();

  return useQuery<TopicReleasePolicy | null, unknown, TData, Key>({
    queryKey: ["topic-release-policy", topicId, releaseId],
    queryFn: () => getTopicReleasePolicy(topicId, releaseId),
    ...options,
  });
}

export function getTopicReleasePolicySelector(data: TopicReleasePolicy | null) {
  return data?.id;
}

export function useGetTopicReleasePolicyId(topicId: number, releaseId: number) {
  return useGetTopicReleasePolicy({
    topicId,
    releaseId,
    select: getTopicReleasePolicySelector,
  });
}
